export enum NotificationSource {
	NEWORDER = "orderNotification",
	NEWUSER = "newUser",
	POSCHECKSAVE = "posCheckSave",
}
